import React, { ReactElement } from 'react';
import { StyledButton, StyledDangerButton } from './styles';

type MenuOptionI = {
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  icon?: ReactElement;
  label?: string;
  noFill?: boolean;
  'data-testid'?: string;
};

export const MenuOption = React.forwardRef<HTMLDivElement, MenuOptionI>(
  (props, ref) => {
    const { onClick, icon, label, noFill } = props;
    return (
      <div ref={ref}>
        <StyledButton
          data-testid={props['data-testid']}
          onClick={onClick}
          label={label}
          noFill={noFill}
          icon={icon}
        />
      </div>
    );
  }
);

export const MenuDangerOption = React.forwardRef<HTMLDivElement, MenuOptionI>(
  (props, ref) => {
    const { onClick, icon, label } = props;
    return (
      <div ref={ref}>
        <StyledDangerButton
          data-testid={props['data-testid']}
          onClick={onClick}
          label={label}
          icon={icon}
        />
      </div>
    );
  }
);
